// lib/organisation-teams/team-access.ts

export interface OrganisationAccessUserInfo {
  isFaterAdmin?: boolean | null;
  isOrganisationAdmin?: boolean | null;
  userOrgId?: string | null;
}

/** Canonical authorisation predicate for organisation-scoped API surfaces (teams, plans, credits, members, analytics). */
export const isAuthorizedForOrganisation = (userInfo: OrganisationAccessUserInfo, organisationId: string): boolean =>
  Boolean(userInfo.isFaterAdmin || (userInfo.isOrganisationAdmin && userInfo.userOrgId === organisationId));
